/**
 * rn-club-tier.js
 * Bio popover for collaborative club cards.
 * - Shows the "More" trigger only when the bio is actually clamped.
 * - Opens the full bio in a floating mini-card that does NOT reflow the grid.
 * - Flips above the trigger when it would overflow the viewport bottom.
 * - Closes on outside click and Escape. Only one popover open at a time.
 */

(function () {
  function initClubBioPopovers() {
    var wraps = Array.prototype.slice.call(document.querySelectorAll('[data-bio-wrap]'));
    if (!wraps.length) return;

    var openController = null;

    function closeOpen() {
      if (!openController) return;
      openController.close();
      openController = null;
    }

    wraps.forEach(function (wrap) {
      var bio = wrap.querySelector('[data-bio-text]');
      var btn = wrap.querySelector('[data-bio-toggle]');
      var popover = wrap.querySelector('[data-bio-popover]');
      var card = wrap.closest('.rn-club-tier__card--collaborative');

      if (!bio || !btn || !popover) return;

      // Only enable the trigger when the preview text is actually clamped.
      if (bio.scrollHeight <= bio.clientHeight + 1) return;

      btn.classList.add('is-visible');

      var labelEl = btn.querySelector('.rn-club-tier__bio-toggle-label');

      function open() {
        closeOpen();

        popover.hidden = false;
        // Decide flip direction based on available space below the trigger.
        popover.classList.remove('rn-club-tier__bio-popover--up');
        var btnRect = btn.getBoundingClientRect();
        var spaceBelow = window.innerHeight - btnRect.bottom;
        // Reveal first so we can measure height, then flip if needed.
        // rAF lets layout settle before measuring.
        requestAnimationFrame(function () {
          var popHeight = popover.offsetHeight;
          if (spaceBelow < popHeight + 24 && btnRect.top > popHeight + 24) {
            popover.classList.add('rn-club-tier__bio-popover--up');
          }
          popover.classList.add('is-open');
        });

        if (card) card.classList.add('is-popover-open');
        btn.setAttribute('aria-expanded', 'true');
        if (labelEl) labelEl.textContent = 'Close';

        controller.isOpen = true;
        openController = controller;
      }

      function close() {
        popover.classList.remove('is-open');
        if (card) card.classList.remove('is-popover-open');
        btn.setAttribute('aria-expanded', 'false');
        if (labelEl) labelEl.textContent = 'More';
        controller.isOpen = false;

        // Hide after the transition so it can't be tab-focused while invisible.
        var onDone = function () {
          if (!controller.isOpen) popover.hidden = true;
          popover.removeEventListener('transitionend', onDone);
        };
        popover.addEventListener('transitionend', onDone);
      }

      var controller = { isOpen: false, close: close };

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (controller.isOpen) {
          close();
          openController = null;
        } else {
          open();
        }
      });

      // Clicks inside the popover shouldn't close it.
      popover.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    // Global dismissers.
    document.addEventListener('click', closeOpen);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeOpen();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initClubBioPopovers);
  } else {
    initClubBioPopovers();
  }
})();